import "./NerAanalysis.scss";
import { useMemo } from "react";

const sortAndFilterData = (data: any) => {
  if (!data?.length) return [];
  return [...data]
    .sort((a, b) => (a.frequency > b.frequency ? -1 : 1))
    .slice(0, 5);
};

const NerAanalysis = ({ data }: any) => {
  const nerData = useMemo(() => sortAndFilterData(data), [data]);

  return (
    <div className="ner-pill-wrap">
      {nerData.length > 0 ? (
        nerData.map((item: any, index: number) => (
          <span key={index} className="ner-pill">{item.entity}</span>
        ))
      ) : (
        <p className="ner-empty">No data</p>
      )}
    </div>
  );
};

export default NerAanalysis;
